import moment from 'moment';

import { BaselineMeasurementVersion } from '../common/constants/general';

import type { ITreatmentPlanGoal } from '../../../../../utils/types';

export enum ThresholdTypes {
  Percent = 'percent',
  Number = 'number',
}

export enum GoalTypes {
  BehaviorReduction = 'behavior_reduction',
  SkillAcquisition = 'skill_acquisition',
  Caregiver = 'caregiver',
}

export enum TreatmentPlanGoalStatus {
  'New goal' = 'new',
  'Not introduced' = 'not_introduced',
  'In-progress' = 'in_progress',
}

export enum GoalMeasurementDurationUnit {
  Session = 'session',
  'Treatment Plan' = 'treatment plan',
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum GoalHypothesizedFunctionResponses {
  Sensory = 'Sensory',
  'Escape / Avoidance' = 'Escape / Avoidance',
  Attention = 'Attention',
  Tangible = 'Tangible',
}

export const initialTreatmentPlanGoal: ITreatmentPlanGoal = {
  goal_type: GoalTypes.BehaviorReduction,
  is_maladaptive_correction: false,
  data_collection_method: null,
  measurement_units: null,
  mastery_criteria: null,
  status_at_creation: TreatmentPlanGoalStatus['Not introduced'],
  date_introduced: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
  baseline_at_creation: '',
  current_level_at_creation: '',
  resource_versions: {
    baseline_measurement: BaselineMeasurementVersion.V2,
  },
  targets: [],
  is_active: true,
  dirty: false,
};
